export { WrapperAd as Ad }  from './WrapperAd';
export type { AdProps } from './Ad';
export { TargecyTracker } from './misc';